import request from '../request'
import { getWebAuthHost } from '../base'

let baseHost = getWebAuthHost()

// 登陆
export function login (data) {
  return request({
    url: `${baseHost}/api/v1/user/login`,
    method: 'POST',
    data: data
  })
}

// 获取用户信息
export function userInfo () {
  return request({
    url: `${baseHost}/api/v1/user/login`,
    method: 'GET',
  })
}

// 注册
export function sign (data) {
  return request({
    url: `${baseHost}/api/v1/user/login`,
    method: 'PUT',
    data: data
  })
}

// 获取用户名是否存在
export function exists(params) {
  return request({
    url: `${baseHost}/api/v1/user/other`,
    method: 'GET',
    params: params
  })
}

// 发送激活邮件
export function sendActive(data) {
  return request({
    url: `${baseHost}/api/v1/user/active`,
    method: 'POST',
    data: data
  })
}

// 重置密码
export function reset(data) {
  return request({
    url: `${baseHost}/api/v1/user/other`,
    method: 'PUT',
    data: data
  })
}

// 上传记录
export function postRecord(data) {
  return request({
    url: `${baseHost}/api/v1/analysis/used_record`,
    method: 'POST',
    data: data
  })
}
